import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Header, Footer } from "../../Components";
import { Outlet } from "react-router-dom";
import { UserContext } from "../../Context";
import { LOGIN } from "../../routes";
import { UNAUTHORIZED_ROUTES } from ".";

const Layout = ({ children }) => {
  const { user } = useContext(UserContext);
  const location = window.location.pathname;
  const isLoggedIn = Boolean(user);

  if (!isLoggedIn && location !== LOGIN) {
    return <Navigate to={LOGIN} replace />;
  }
  return (
    <React.Fragment>
      <div>
        <Header />
        <UNAUTHORIZED_ROUTES>
          <main className="md:h-[88vh] overflow-y-auto">
            <Outlet />
          </main>
        </UNAUTHORIZED_ROUTES>
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default Layout;
